import { createIcon } from '@chakra-ui/react';

export const CDV360Icon = createIcon({
    displayName: 'CDV360Icon',
    viewBox: '0 0 2192.7 2428.1',
    path: (
        <g xmlns="http://www.w3.org/2000/svg">
            <path
                className="st0"
                fill="#81C995"
                d="M1730.6,949.3c142.5-86.5,328.1-41.1,414.5,101.4c86.5,142.5,41.1,328.1-101.4,414.5   c-3.8,2.3-7.6,4.5-11.4,6.6L460.2,2377.1c-142.5,86.5-328.1,41.1-414.6-101.4c-86.5-142.5-41.1-328.1,101.4-414.6   c3.8-2.3,7.6-4.5,11.4-6.6L1730.6,949.3z"
            />
            <path
                className="st1"
                fill="#34A853"
                d="M601,303.7C601.7,137.4,467.4,1.9,301.1,1.2c-21.4-0.1-42.7,2.1-63.7,6.5C96.5,42.3-2,169.5,0,314.7v1798.1   l600.4,10.9L601,303.7z"
            />
            <path
                className="st2"
                fill="#5BB974"
                d="M1737.4,1472.9c145.3,75.3,324.1,27.1,411.9-111.1c84.4-142,37.7-325.6-104.3-410c-1.1-0.6-2.1-1.2-3.2-1.9   L459.2,43C318.3-42.1,135,3.1,49.8,144c-2.1,3.5-4.2,7.1-6.2,10.7C-40,297.8,8.2,481.7,151.3,565.4c1,0.6,2,1.1,3,1.7   L1737.4,1472.9z"
            />
            <path
                className="st0"
                fill="#81C995"
                d="M2031.4,1475L600.5,2274.3v-686.6l1135.4-633.1c150.5-83.4,340.2-29,423.6,121.6c7.8,14,14.4,28.6,19.9,43.6   C2222,1258.3,2159.8,1407.6,2031.4,1475z"
            />
            <circle
                className="st3"
                fill="#1E8E3E"
                cx="300.8"
                cy="2127.8"
                r="300.2"
            />
        </g>
    ),
});

export const CTradeDeskIcon = createIcon({
    displayName: 'CTradeDeskIcon',
    viewBox: '0 0 1508 1589',
    path: (
        <g xmlns="http://www.w3.org/2000/svg" id="Layer">
            <g id="Layer">
                <path
                    id="Layer"
                    fill="#0099fa"
                    d="m875.7 0.4v243.6 649.7h-244.1v-645.9h-253.5v-247.4z"
                />
                <g id="Layer">
                    <path
                        id="Layer"
                        fill="#0099fa"
                        d="m514.3 1285.4v264.4c-298.9-99.9-514.3-381.6-514.3-713.5 0-167.4 54.8-321.8 147.4-446.7h362.1v0.1c-158.1 86.3-265.4 253.9-265.4 446.6 0 194.5 109.5 363.5 270.2 449.1z"
                    />
                    <path
                        id="Layer"
                        fill="#0099fa"
                        d="m1507.4 836.3c0 415.5-337.5 752.3-753.7 752.3-41.5 0-82.1-3.4-121.8-9.8v-248.5c39 9.5 79.8 14.6 121.8 14.6 281.4 0 509.7-227.7 509.7-508.6 0-192.7-107.4-360.3-265.6-446.7v-265.1c296.4 101.2 509.6 381.5 509.6 711.8z"
                    />
                </g>
            </g>
        </g>
    ),
});

export const CVibenomicsIcon = createIcon({
    displayName: 'CVibenomicsIcon',
    viewBox: '0 0 709 709',
    path: (
        <>
            <path
                fill="#FFFFFF"
                opacity="1.000000"
                stroke="none"
                d=" M410.000000,710.000000   C273.333344,710.000000 137.166672,710.000000 1.000000,710.000000   C1.000000,473.666656 1.000000,237.333328 1.000000,1.000000   C237.333328,1.000000 473.666656,1.000000 710.000000,1.000000   C710.000000,237.333328 710.000000,473.666656 710.000000,710.000000   C610.166687,710.000000 510.333344,710.000000 410.000000,710.000000  M87.119644,129.205856   C86.648628,127.999741 86.177620,126.793625 85.706604,125.587502   C85.522881,125.653961 85.339149,125.720421 85.155426,125.786880   C85.155426,127.197060 85.155426,128.607239 85.033264,130.690521   C85.075752,131.142227 85.118248,131.593948 85.016426,132.966339   C85.009048,172.951797 84.997940,212.937271 84.995071,252.922729   C84.989014,337.392426 84.998993,421.862122 84.937149,506.331787   C84.934883,509.428986 85.060066,512.022949 89.383614,512.946716   C146.194092,537.318054 203.002365,561.694580 259.829071,586.028015   C261.129791,586.585022 262.639374,586.654358 263.978943,587.282288   C264.100555,587.268555 264.222137,587.254822 264.343750,587.241089   C264.224854,587.161377 264.105927,587.081726 263.968140,586.250549   C247.154465,542.650879 230.375885,499.037598 213.519852,455.454315   C177.704605,362.849670 141.864532,270.254608 105.995239,177.670853   C99.814133,161.716522 93.438774,145.837433 87.119644,129.205856  M218.895523,154.768799   C234.908813,196.358841 250.873123,237.967804 266.946686,279.534515   C291.841858,343.914093 316.790100,408.273132 341.771576,472.619232   C345.789856,482.969391 350.097534,493.207214 354.319946,504.116058   C354.483276,504.490479 354.646637,504.864929 354.758057,505.840210   C354.811859,506.033905 354.865692,506.227631 354.954742,507.305115   C354.954742,547.142944 354.954742,586.980774 354.954742,627.167114   C356.892609,626.520935 358.493011,626.109192 359.995300,625.467651   C376.468353,618.433105 392.958740,611.437561 409.377197,604.277344   C421.647003,598.926331 433.818542,593.349976 446.701294,587.656189   C504.541595,562.835449 562.366821,537.979309 620.258606,513.279297   C623.829346,511.755798 625.119202,510.093994 625.114624,506.058136   C624.978149,386.298218 625.006531,266.538086 624.997437,146.778000   C624.996887,139.618088 624.902710,132.458191 624.960754,124.668587   C623.974121,124.445663 622.987427,124.222740 621.760559,123.245316   C614.208740,122.069824 606.664917,120.840530 599.103821,119.728020   C563.235657,114.450508 527.363770,109.198372 491.491364,103.949753   C458.252075,99.086411 425.053741,93.910271 391.751801,89.521317   C374.759583,87.281860 358.073456,82.834862 340.380371,85.787689   C302.987366,92.028244 265.383301,97.004623 227.864700,102.492149   C199.230453,106.680237 170.592728,110.844620 141.959991,115.043076   C123.613434,117.733253 105.273140,120.466217 86.930038,123.179993   C128.224884,132.827087 169.530304,141.893494 210.814804,151.054169   C213.629135,151.678635 216.286530,153.010330 218.895523,154.768799  z"
            />
            <path
                fill="#E3E2E3"
                opacity="1.000000"
                stroke="none"
                d=" M622.000793,123.999817   C622.987427,124.222740 623.974121,124.445663 624.640503,125.182686   C620.595398,135.300812 616.863708,144.902176 613.146790,154.509293   C560.987427,289.324707 508.820312,424.137177 456.692780,558.964905   C452.989624,568.543213 449.580017,578.234985 446.033875,587.873962   C433.818542,593.349976 421.647003,598.926331 409.377197,604.277344   C392.958740,611.437561 376.468353,618.433105 359.995300,625.467651   C358.493011,626.109192 356.892609,626.520935 354.954742,627.167114   C354.954742,586.980774 354.954742,547.142944 355.229309,506.744263   C355.632507,505.802277 355.761108,505.421143 356.005249,504.689209   C365.373169,480.486115 374.643005,456.640533 383.874695,432.780182   C419.540375,340.598297 455.205292,248.416107 490.794403,156.204666   C491.811523,153.569321 493.129822,152.406311 495.973206,151.786423   C538.004028,142.623215 579.998047,133.291550 622.000793,123.999817  z"
            />
            <path
                fill="#332A4B"
                opacity="1.000000"
                stroke="none"
                d=" M621.880676,123.622566   C579.998047,133.291550 538.004028,142.623215 495.973206,151.786423   C493.129822,152.406311 491.811523,153.569321 490.794403,156.204666   C455.205292,248.416107 419.540375,340.598297 383.874695,432.780182   C374.643005,456.640533 365.373169,480.486115 355.730865,504.713623   C355.163940,505.138977 354.986938,505.189178 354.809967,505.239349   C354.646637,504.864929 354.483276,504.490479 354.523529,503.346863   C354.814728,500.752838 354.978668,498.927979 354.979004,497.103149   C354.998505,396.176697 355.002167,295.250244 355.014435,194.323792   C355.015869,182.456711 354.995392,182.638016 343.571075,180.185120   C310.487762,173.081879 277.451111,165.761459 244.367630,158.658981   C235.971878,156.856552 227.470016,155.548386 219.016922,154.013123   C216.286530,153.010330 213.629135,151.678635 210.814804,151.054169   C169.530304,141.893494 128.224884,132.827087 86.930038,123.179993   C105.273140,120.466217 123.613434,117.733253 141.959991,115.043076   C170.592728,110.844620 199.230453,106.680237 227.864700,102.492149   C265.383301,97.004623 302.987366,92.028244 340.380371,85.787689   C358.073456,82.834862 374.759583,87.281860 391.751801,89.521317   C425.053741,93.910271 458.252075,99.086411 491.491364,103.949753   C527.363770,109.198372 563.235657,114.450508 599.103821,119.728020   C606.664917,120.840530 614.208740,122.069824 621.880676,123.622566  z"
            />
            <path
                fill="#332A4B"
                opacity="1.000000"
                stroke="none"
                d=" M446.367584,587.765076   C449.580017,578.234985 452.989624,568.543213 456.692780,558.964905   C508.820312,424.137177 560.987427,289.324707 613.146790,154.509293   C616.863708,144.902176 620.595398,135.300812 624.586182,125.497528   C624.902710,132.458191 624.996887,139.618088 624.997437,146.778000   C625.006531,266.538086 624.978149,386.298218 625.114624,506.058136   C625.119202,510.093994 623.829346,511.755798 620.258606,513.279297   C562.366821,537.979309 504.541595,562.835449 446.367584,587.765076  z"
            />
            <path
                fill="#6D6DB5"
                opacity="1.000000"
                stroke="none"
                d=" M264.051514,586.951233   C262.639374,586.654358 261.129791,586.585022 259.829071,586.028015   C203.002365,561.694580 146.194092,537.318054 89.152115,512.315979   C82.860931,495.842712 86.238792,479.364594 86.185135,463.236572   C85.824295,354.762268 86.000671,246.286209 85.961006,137.810745   C85.960297,135.888947 85.439079,133.967346 85.160736,132.045654   C85.118248,131.593948 85.075752,131.142227 85.427589,130.345840   C86.265656,129.975311 86.709404,129.949448 87.153145,129.923584   C93.438774,145.837433 99.814133,161.716522 105.995239,177.670853   C141.864532,270.254608 177.704605,362.849670 213.519852,455.454315   C230.375885,499.037598 247.154465,542.650879 263.994354,586.614868   C264.020569,586.979248 264.051514,586.951233 264.051514,586.951233  z"
            />
            <path
                fill="#6D6DB4"
                opacity="1.000000"
                stroke="none"
                d=" M218.956223,154.390961   C227.470016,155.548386 235.971878,156.856552 244.367630,158.658981   C277.451111,165.761459 310.487762,173.081879 343.571075,180.185120   C354.995392,182.638016 355.015869,182.456711 355.014435,194.323792   C355.002167,295.250244 354.998505,396.176697 354.979004,497.103149   C354.978668,498.927979 354.814728,500.752838 354.499268,503.037292   C350.097534,493.207214 345.789856,482.969391 341.771576,472.619232   C316.790100,408.273132 291.841858,343.914093 266.946686,279.534515   C250.873123,237.967804 234.908813,196.358841 218.956223,154.390961  z"
            />
            <path
                fill="#726FA6"
                opacity="1.000000"
                stroke="none"
                d=" M85.088577,132.505997   C85.439079,133.967346 85.960297,135.888947 85.961006,137.810745   C86.000671,246.286209 85.824295,354.762268 86.185135,463.236572   C86.238792,479.364594 82.860931,495.842712 88.876755,512.122925   C85.060066,512.022949 84.934883,509.428986 84.937149,506.331787   C84.998993,421.862122 84.989014,337.392426 84.995071,252.922729   C84.997940,212.937271 85.009048,172.951797 85.088577,132.505997  z"
            />
            <path
                fill="#726FA6"
                opacity="1.000000"
                stroke="none"
                d=" M87.136398,129.564728   C86.709404,129.949448 86.265656,129.975311 85.488670,130.009277   C85.155426,128.607239 85.155426,127.197060 85.155426,125.786880   C85.339149,125.720421 85.522881,125.653961 85.706604,125.587502   C86.177620,126.793625 86.648628,127.999741 87.136398,129.564728  z"
            />
            <path
                fill="#6D6DB4"
                opacity="1.000000"
                stroke="none"
                d=" M354.783997,505.539795   C354.986938,505.189178 355.163940,505.138977 355.615295,505.064362   C355.761108,505.421143 355.632507,505.802277 355.211700,506.302368   C354.865692,506.227631 354.811859,506.033905 354.783997,505.539795  z"
            />
            <path
                fill="#6D6DB5"
                opacity="1.000000"
                stroke="none"
                d=" M264.003784,586.990601   C264.105927,587.081726 264.224854,587.161377 264.343750,587.241089   C264.222137,587.254822 264.100555,587.268555 264.015228,587.116760   C264.051514,586.951233 264.020569,586.979248 264.003784,586.990601  z"
            />
        </>
    ),
});

export const CYIcon = createIcon({
    displayName: 'CYIcon',
    viewBox: '0 0 512 512',
    path: (
        <>
            <rect width="512" height="512" rx="15%" fill="#5f01d1" />
            <g fill="#ffffff">
                <path d="M203 404h-62l25-59-69-165h63l37 95 37-95h62m58 76h-69l62-148h69" />

                <circle cx="303" cy="308" r="38" />
            </g>
        </>
    ),
});

export const CPinterestIcon = createIcon({
    displayName: 'CPinterestIcon',
    viewBox: '0 0 256 256',
    path: (
        <g>
            <path
                d="M0,128.002 C0,180.416 31.518,225.444 76.619,245.241 C76.259,236.303 76.555,225.573 78.847,215.848 C81.308,205.457 95.317,146.1 95.317,146.1 C95.317,146.1 91.228,137.927 91.228,125.848 C91.228,106.879 102.222,92.712 115.914,92.712 C127.557,92.712 133.182,101.457 133.182,111.929 C133.182,123.633 125.717,141.14 121.878,157.355 C118.671,170.933 128.686,182.008 142.081,182.008 C166.333,182.008 182.667,150.859 182.667,113.953 C182.667,85.899 163.772,64.901 129.405,64.901 C90.577,64.901 66.388,93.857 66.388,126.201 C66.388,137.353 69.676,145.217 74.826,151.307 C77.194,154.104 77.523,155.229 76.666,158.441 C76.052,160.796 74.642,166.466 74.058,168.713 C73.206,171.955 70.579,173.114 67.649,171.917 C49.765,164.616 41.436,145.031 41.436,123.015 C41.436,86.654 72.102,43.054 132.918,43.054 C181.788,43.054 213.953,78.418 213.953,116.379 C213.953,166.592 186.037,204.105 144.887,204.105 C131.068,204.105 118.069,196.635 113.616,188.15 C113.616,188.15 106.185,217.642 104.611,223.337 C101.897,233.206 96.585,243.07 91.728,250.758 C103.24,254.156 115.401,256.007 128.005,256.007 C198.689,256.007 256.001,198.698 256.001,128.002 C256.001,57.309 198.689,0 128.005,0 C57.314,0 0,57.309 0,128.002 Z"
                fill="#CB1F27"
            />
        </g>
    ),
});

export const CSA360Icon = createIcon({
    displayName: 'CSA360Icon',
    viewBox: '0 0 192 192',
    path: (
        <>
            <path
                style={{
                    fill: '#ffffff',
                    stroke: 'none',
                }}
                d="M0 0L0 192L192 192L192 0L0 0z"
            />
            <path
                style={{
                    fill: '#669df6',
                    stroke: 'none',
                }}
                d="M76 13.439C65.363 15.1004 55.0527 18.8391 46 24.6991C1.04234 53.8008 2.94035 121.982 47 150.655C54.2522 155.375 62.4939 158.756 71 160.388C79.4644 162.012 88.4171 162.801 97 161.572C108.382 159.941 118.518 156.57 128 150.024C139.335 142.198 149.796 131.743 155.558 119C175.38 75.1606 149.093 23.5302 102 14.0039C93.9037 12.3661 84.1773 12.1619 76 13.439z"
            />
            <path
                style={{
                    fill: '#ffffff',
                    stroke: 'none',
                }}
                d="M82 55.4645C76.9244 56.3796 72.091 58.3676 68.0008 61.5293C46.81 77.9099 53.2966 111.236 79 118.571C83.289 119.795 87.5771 120.331 92 119.535C97.3355 118.576 102.603 116.396 106.996 113.211C133.943 93.6818 114.305 49.6399 82 55.4645z"
            />
            <path
                style={{
                    fill: '#1a73e8',
                    stroke: 'none',
                }}
                d="M152 124C144.225 136.395 134.412 144.228 123 153C127.454 159.322 133.54 164.54 139 170C142.713 173.712 146.331 178.043 151 180.583C167.416 189.509 183.986 175.222 181.815 158C180.541 147.901 170.72 140.719 164 134C160.258 130.259 156.832 126.253 152 124z"
            />
        </>
    ),
});

export const CFacebookIcon = createIcon({
    displayName: 'CFacebookIcon',
    viewBox: '0 0 666.66668 666.66717',
    path: (
        <g
            id="g17"
            transform="matrix(1.3333333,0,0,-1.3333333,-133.33333,799.99999)"
        >
            <g id="g19">
                <g id="g21" clipPath="url(#clipPath25)">
                    <g id="g27" transform="translate(600,350)">
                        <path
                            d="m 0,0 c 0,138.071 -111.929,250 -250,250 -138.071,0 -250,-111.929 -250,-250 0,-117.245 80.715,-215.622 189.606,-242.638 v 166.242 h -51.552 V 0 h 51.552 v 32.919 c 0,85.092 38.508,124.532 122.048,124.532 15.838,0 43.167,-3.105 54.347,-6.211 V 81.986 c -5.901,0.621 -16.149,0.932 -28.882,0.932 -40.993,0 -56.832,-15.528 -56.832,-55.9 V 0 h 81.659 l -14.028,-76.396 h -67.631 V -248.169 C -95.927,-233.218 0,-127.818 0,0"
                            style={{
                                fill: '#0866ff',
                                fillOpacity: 1,
                                fillRule: 'nonzero',
                                stroke: 'none',
                            }}
                            id="path29"
                        />
                    </g>
                    <g id="g31" transform="translate(447.9175,273.6036)">
                        <path
                            d="M 0,0 14.029,76.396 H -67.63 v 27.019 c 0,40.372 15.838,55.899 56.831,55.899 12.733,0 22.981,-0.31 28.882,-0.931 v 69.253 c -11.18,3.106 -38.509,6.212 -54.347,6.212 -83.539,0 -122.048,-39.441 -122.048,-124.533 V 76.396 h -51.552 V 0 h 51.552 v -166.242 c 19.343,-4.798 39.568,-7.362 60.394,-7.362 10.254,0 20.358,0.632 30.288,1.831 L -67.63,0 Z"
                            style={{
                                fill: '#ffffff',
                                fillOpacity: 1,
                                fillRule: 'nonzero',
                                stroke: 'none',
                            }}
                            id="path33"
                        />
                    </g>
                </g>
            </g>
        </g>
    ),
});

export const CGoogleShoppingIcon = createIcon({
    displayName: 'CGoogleShoppingIcon',
    viewBox: '.381 -4.99021715 516.22889793 516.22821715',
    path: (
        <g fill="none" fillRule="evenodd">
            <path
                d="m411.503 136.66c20.182 0 36.545-16.362 36.545-36.544s-16.363-36.544-36.545-36.544-36.544 16.362-36.544 36.544 16.362 36.544 36.544 36.544zm-258.888-11.155 112.108-112.108c8.552-8.552 20.428-13.777 33.493-13.777h166.276a47.343 47.343 0 0 1 47.508 47.507v166.276c0 13.065-5.226 24.942-14.015 33.493l-111.937 112.044z"
                fill="#4285f4"
            />
            <path
                d="m386.048 358.94-138.153 138.283c-8.79 8.551-20.666 14.015-33.73 14.015s-24.942-5.464-33.493-14.015l-166.277-166.275c-8.789-8.552-14.014-20.428-14.014-33.493 0-13.302 5.463-25.179 14.014-33.73l138.22-138.22z"
                fill="#34a853"
            />
            <path
                d="m95.085 411.637-80.69-80.69c-8.789-8.549-14.014-20.427-14.014-33.491 0-13.302 5.463-25.179 14.014-33.73l138.22-138.22 114.3 114.302z"
                fill="#fbbc05"
            />
            <path
                d="m495.595 11.127a47.344 47.344 0 0 0 -31.103-11.507h-166.276c-13.065 0-24.941 5.225-33.493 13.777l-112.108 112.108 114.3 114.302 116.415-116.415a36.394 36.394 0 0 1 -8.37-23.276c0-20.182 16.361-36.544 36.543-36.544a36.394 36.394 0 0 1 23.277 8.37z"
                fill="#ea4335"
            />
            <circle cx="266.849" cy="252.764" fill="#4285f4" r="74.23" />
            <path
                d="m367.983 230.928h-98.726v42.358h56.828c-5.298 26.91-27.45 42.358-56.828 42.358-34.675 0-62.607-28.903-62.607-64.783s27.932-64.783 62.607-64.783c14.93 0 28.414 5.482 39.009 14.452l30.822-31.894c-18.782-16.943-42.862-27.408-69.831-27.408-58.754 0-105.95 48.837-105.95 109.633s47.196 109.633 105.95 109.633c52.975 0 101.134-39.867 101.134-109.633 0-6.478-.963-13.455-2.408-19.933z"
                fill="#fff"
            />
        </g>
    ),
});

export const CGoogleAdManagerIcon = createIcon({
    displayName: 'CGoogleAdManagerIcon',
    viewBox: '0 0 2454.3 2454.3',
    path: (
        <g>
            <path
                className="st0"
                fill="#FBBC04"
                d="M2385.8,1385L1385,2385.8c-91.3,91.3-239.4,91.3-330.7,0c-91.4-91.3-91.3-239.4,0-330.7l1000.9-1000.9   c91.3-91.3,239.4-91.3,330.7,0C2477.2,1145.6,2477.2,1293.6,2385.8,1385L2385.8,1385z"
            />
            <ellipse
                transform="matrix(0.7071 -0.7071 0.7071 0.7071 -1212.9008 1512.7477)"
                className="st1"
                fill="#34A853"
                cx="1219.6"
                cy="2220.5"
                rx="233.9"
                ry="233.9"
            />
            <path
                className="st0"
                fill="#FBBC04"
                d="M1562.3,561.4l-500.5,500.4l330.7,330.7L1893,892.1c91.3-91.3,91.3-239.4,0-330.7   C1801.6,470,1653.6,470,1562.3,561.4L1562.3,561.4z"
            />
            <path
                className="st2"
                fill="#3B80EF"
                d="M892.1,1893l500.4-500.4l-330.7-330.7l-500.4,500.4c-91.3,91.3-91.3,239.4,0,330.7   C652.7,1984.3,800.8,1984.3,892.1,1893L892.1,1893z"
            />
            <ellipse
                transform="matrix(0.7071 -0.7071 0.7071 0.7071 -507.2274 1227.6238)"
                className="st1"
                fill="#34A853"
                cx="1228.3"
                cy="1226.1"
                rx="233.9"
                ry="233.9"
            />
            <path
                className="st2"
                fill="#3B80EF"
                d="M1400.1,399.2L399.2,1400.1c-91.3,91.3-239.4,91.3-330.7,0c-91.3-91.3-91.3-239.4,0-330.7L1069.4,68.5   c91.3-91.3,239.4-91.3,330.7,0C1491.4,159.8,1491.4,307.9,1400.1,399.2L1400.1,399.2z"
            />
            <circle
                className="st1"
                fill="#34A853"
                cx="1234.7"
                cy="233.9"
                r="233.9"
            />
        </g>
    ),
});

export const CMarriottIcon = createIcon({
    displayName: 'CMarriottIcon',
    viewBox: '0 0 388.9 305.4',
    path: (
        <g>
            <polygon points="75.8,268.7 81.8,268.7 92,285.6 102.1,268.7 108.1,268.7 109.7,304.5 103.5,304.5 102.3,279.7 93.4,294.3   90.3,294.3 81.3,280 80.2,304.5 74.2,304.5 " />
            <path d="M143.3,289.8l-4.5-13.9l-4.6,13.9H143.3z M135.6,268.7h6.6l12.9,35.8h-7.2l-3-9.1h-12.7l-3,9.1h-6.7L135.6,268.7z" />
            <path d="M181.7,284.8c1.6,0,2.9-0.5,3.8-1.5c0.9-1,1.4-2.2,1.4-3.7c0-1.5-0.5-2.8-1.4-3.8c-1-1-2.2-1.4-3.7-1.4h-6.8v10.4H181.7z   M168.7,268.7h12.9c2.1,0,4,0.3,5.5,1c1.5,0.7,2.7,1.5,3.6,2.6c0.9,1.1,1.6,2.2,2,3.5c0.4,1.3,0.6,2.5,0.6,3.6c0,2.2-0.5,4.3-1.4,6  c-0.9,1.7-2.4,3.1-4.3,4.2l7.9,15h-7.3l-6.9-14.1h-6.5v14.1h-6.2V268.7z" />
            <path d="M223,284.8c1.6,0,2.9-0.5,3.8-1.5c0.9-1,1.4-2.2,1.4-3.7c0-1.5-0.5-2.8-1.4-3.8c-1-1-2.2-1.4-3.7-1.4h-6.8v10.4H223z   M210.1,268.7H223c2.1,0,4,0.3,5.5,1c1.5,0.7,2.7,1.5,3.6,2.6c0.9,1.1,1.6,2.2,2,3.5c0.4,1.3,0.6,2.5,0.6,3.6c0,2.2-0.5,4.3-1.4,6  c-0.9,1.7-2.4,3.1-4.3,4.2l7.9,15h-7.3l-6.9-14.1h-6.4v14.1h-6.2V268.7z" />
            <rect x="253" y="268.7" width="6.4" height="35.8" />
            <path d="M292.7,299.1c1.7,0,3.2-0.3,4.6-1c1.4-0.7,2.5-1.6,3.5-2.8c1-1.2,1.7-2.5,2.2-4.1c0.5-1.5,0.8-3.1,0.8-4.8  c0-1.7-0.3-3.3-0.8-4.9c-0.5-1.5-1.2-2.9-2.2-4c-1-1.2-2.1-2.1-3.5-2.7c-1.4-0.7-2.9-1-4.6-1c-1.7,0-3.2,0.3-4.6,1  c-1.3,0.7-2.5,1.6-3.4,2.7c-1,1.1-1.7,2.5-2.2,4c-0.5,1.5-0.8,3.1-0.8,4.9c0,1.7,0.3,3.3,0.8,4.8c0.5,1.5,1.2,2.9,2.2,4.1  c1,1.2,2.1,2.1,3.4,2.8C289.5,298.7,291,299.1,292.7,299.1 M292.7,305.4c-2.5,0-4.8-0.5-7-1.5c-2.1-1-4-2.3-5.6-4  c-1.6-1.7-2.9-3.7-3.8-6c-0.9-2.3-1.4-4.7-1.4-7.4c0-2.6,0.5-5.1,1.4-7.4c0.9-2.3,2.2-4.3,3.8-6c1.6-1.7,3.4-3,5.6-4  c2.2-1,4.5-1.5,7-1.5c2.5,0,4.8,0.5,7,1.5c2.1,1,4,2.3,5.6,4c1.6,1.7,2.9,3.7,3.8,6c0.9,2.3,1.4,4.7,1.4,7.4c0,2.6-0.5,5.1-1.4,7.4  c-0.9,2.3-2.2,4.3-3.8,6c-1.6,1.7-3.5,3.1-5.6,4C297.5,304.9,295.2,305.4,292.7,305.4" />
            <polygon points="330.4,274.6 318.9,274.6 318.9,268.7 348.4,268.7 348.4,274.6 336.9,274.6 336.9,304.5 330.4,304.5 " />
            <polygon points="370.9,274.6 359.3,274.6 359.3,268.7 388.9,268.7 388.9,274.6 377.3,274.6 377.3,304.5 370.9,304.5 " />
            <path
                fill="#A11D2B"
                d="M248.4,232.9h57.5L209.7,3.7l-48.3,23.4l33.6,79.8L179.4,144L119.2,0L70.4,22.3l39.2,92l-0.2,0.4  c-24.2,58.1-53.8,74-56.7,75.1c-6.9,2.8-14.3,4.4-22.1,4.4c-2.4,0-4.7-0.1-7-0.4L0,244.4c7.8,4.5,16.6,7.1,25.9,7.1  c11.8,0,22.6-4.1,31.6-10.9l-0.1,0.2c0,0,22.3-11.3,46.2-73.2c0-0.1,8.8-19.8,13.5-32.4l0.5-1.4l42,99.2H217l-29.6-69.8l15.7-37.1  L248.4,232.9z"
            />
        </g>
    ),
});

export const CMetaIcon = createIcon({
    displayName: 'CMetaIcon',
    viewBox: '0 0 287.56 191',
    path: (
        <>
            <defs>
                <linearGradient
                    id="metaGradient"
                    x1="0%"
                    y1="0%"
                    x2="100%"
                    y2="100%"
                >
                    <stop offset="0%" stopColor="#1877F2" />
                    {/* Adjust colors */}
                    <stop offset="100%" stopColor="#8B9DC3" />
                </linearGradient>
            </defs>
            <path
                d="M31.06,126c0,11,2.41,19.41,5.56,24.51A19,19,0,0,0,53.19,160c8.1,0,15.51-2,29.79-21.76,11.44-15.83,24.92-38,34-52l15.36-23.6c10.67-16.39,23-34.61,37.18-47C181.07,5.6,193.54,0,206.09,0c21.07,0,41.14,12.21,56.5,35.11,16.81,25.08,25,56.67,25,89.27,0,19.38-3.82,33.62-10.32,44.87C271,180.13,258.72,191,238.13,191V160c17.63,0,22-16.2,22-34.74,0-26.42-6.16-55.74-19.73-76.69-9.63-14.86-22.11-23.94-35.84-23.94-14.85,0-26.8,11.2-40.23,31.17-7.14,10.61-14.47,23.54-22.7,38.13l-9.06,16c-18.2,32.27-22.81,39.62-31.91,51.75C84.74,183,71.12,191,53.19,191c-21.27,0-34.72-9.21-43-23.09C3.34,156.6,0,141.76,0,124.85Z"
                fill="url(#metaGradient)"
            />
            <path
                d="M24.49,37.3C38.73,15.35,59.28,0,82.85,0c13.65,0,27.22,4,41.39,15.61,15.5,12.65,32,33.48,52.63,67.81l7.39,12.32c17.84,29.72,28,45,33.93,52.22,7.64,9.26,13,12,19.94,12,17.63,0,22-16.2,22-34.74l27.4-.86c0,19.38-3.82,33.62-10.32,44.87C271,180.13,258.72,191,238.13,191c-12.8,0-24.14-2.78-36.68-14.61-9.64-9.08-20.91-25.21-29.58-39.71L146.08,93.6c-12.94-21.62-24.81-37.74-31.68-45C107,40.71,97.51,31.23,82.35,31.23c-12.27,0-22.69,8.61-31.41,21.78Z"
                fill="url(#metaGradient)"
            />
            <path
                d="M82.35,31.23c-12.27,0-22.69,8.61-31.41,21.78C38.61,71.62,31.06,99.34,31.06,126c0,11,2.41,19.41,5.56,24.51L10.14,167.91C3.34,156.6,0,141.76,0,124.85,0,94.1,8.44,62.05,24.49,37.3,38.73,15.35,59.28,0,82.85,0Z"
                fill="url(#metaGradient)"
            />
        </>
    ),
});
